@if (!avatarSrc) {
  <div
    [class]="'flex items-center justify-center rounded-full bg-blue-500 dark:bg-blue-600 text-white font-semibold ' + h + ' ' + w"
    [ngClass]="{
      'text-xs': h === 'h-8' || h === 'h-10' || h === 'h-11',
      'text-sm': h === 'h-12' || h === 'h-14',
      'text-lg': h === 'h-16' || h === 'h-20',
      'text-2xl': h === 'h-24' || h === 'h-28',
      'text-4xl': h === 'h-32' || h === 'h-36' || h === 'h-40'
    }"
  >
    {{ userInitial }}
  </div>
} @else {
  <img [class]="'rounded-full object-cover ' + h + ' ' + w" [src]="avatarSrc" alt="User avatar">
}
